import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
})
export class AppTopbarComponent {
  @ViewChild('menubutton') menuButton!: ElementRef;

  constructor(public layoutService: LayoutService) {}

  onMenuButtonClick(): void {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick(): void {
    this.layoutService.showProfileSidebar();
  }
  onConfigButtonClick(): void {
    this.layoutService.showConfigSidebar();
  }
}
